import { CurrencyCode } from "@/dto/currencyCodes";
import { Locale } from "@/dto/locale";
import countryToCurrency, { Currencies, Countries } from "country-to-currency";

export const getCurrencySymbol = (locale: Locale, currency: CurrencyCode) =>
  (0)
    .toLocaleString(locale, {
      style: "currency",
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .replace(/\d/g, "")
    .trim();

export const getCurrencyCodeFromCountry = (
  countryCode: Countries
): Currencies =>
  countryToCurrency[countryCode]

export const toCents = (amount: number) => Math.round((amount ?? 0) * 100);
